import { isOriginalSessionExpiredError as isOriginalSessionExpired } from './token-refresh-policy';

const ORIGINAL_TOKEN_INVALID_CODES = [1002, 1003, 1004, 1005];

interface ResponseLikeError {
  response?: {
    status?: number;
    data?: { code?: unknown };
  };
}

export const shouldRefreshOriginalAuthorization = (error: unknown): boolean => {
  if (!error || typeof error !== 'object') return false;
  const { response } = error as ResponseLikeError;
  const errorCode = Number(response?.data?.code);
  return (
    response?.status === 401 ||
    response?.status === 403 ||
    (Number.isFinite(errorCode) &&
      ORIGINAL_TOKEN_INVALID_CODES.includes(errorCode))
  );
};

export const isOriginalSessionExpiredError = (error: unknown): boolean => {
  return isOriginalSessionExpired(error);
};
